import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createButton: {
		id: 'atlassian-navigation.dashboards.menu.footer.create-button.create-button',
		defaultMessage: 'Create dashboard',
		description: 'Opens create dashboard model',
	},
	notAllowed: {
		id: 'atlassian-navigation.dashboards.menu.footer.create-button.not-allowed',
		defaultMessage: 'You must be logged in to create dashboards',
		description:
			'Shown in the tooltip on hovering a disabled "create dashboard" button for the logged out users without a permission to create a dashboard',
	},
});
